// Keep the original header visible. These labels describe established source fields;
// unfamiliar fields deliberately retain their exact name.
const labels: Record<string, string> = {
  agingdays: "Aging (days)",
  order_id: "Order ID",
  matchsetid: "Match set ID",
  declared_country_code: "Declared country code",
};

export function fieldLabel(name: string): string {
  return labels[name] ? `${labels[name]} · ${name}` : name;
}
